<template>
  <div>
    <div v-if="isGroup && checkList.length > 0">
      <el-checkbox-group v-model="selectedGroup" class="d-flex">
        <el-checkbox v-for="item in checkList" :label="item.name || item" :key="item.id || item">
          {{ item.name || item }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-else class="singleCheckbox">
      <el-checkbox v-model="checked" v-if="withoutLabel"></el-checkbox>
      <el-checkbox v-model="checked" :disabled="disabled" v-else>{{ item.label }}</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'K2Checkbox',
  props: ['list', 'onchange', 'item', 'selected', 'isGroup', 'label', 'state', 'withoutLabel', 'disabled'],
  data() {
    return {
      checkList: [],
      selectedGroup: [],
      checked: null,
      checkAll: false,
    }
  },
  mounted() {
    this.checked = this.state || null
    this.selectedGroup = this.selected
    this.checkList = this.list
  },
  watch: {
    selectedGroup: function (value) {
      this.$emit('onchange', value)
      //alert("selectedGroup:" + JSON.stringify(value));
    },
    selected: function () {
      this.selectedGroup = this.selected
    },
    label: function (value) {
      this.$emit('onchange', value)
    },
    checked: function (value) {
      this.$emit('onchange', value)
    },
    state: function (value) {
      this.checked = value
    },
  },
}
</script>
